import { render, staticRenderFns } from "./ContentSelectorItem.vue?vue&type=template&id=6edc4fa5&scoped=true&"
import script from "./ContentSelectorItem.vue?vue&type=script&lang=js&"
export * from "./ContentSelectorItem.vue?vue&type=script&lang=js&"
import style0 from "./ContentSelectorItem.vue?vue&type=style&index=0&id=6edc4fa5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6edc4fa5",
  null
  
)

export default component.exports